import { all, fork } from 'redux-saga/effects';
import { watchCreateStatusUpdates } from './create';
import { watchDeleteStatusUpdates } from './delete';
import { watchGetStatusUpdates } from './get';
import { watchUpdateStatusUpdates } from './update';

export const statusUpdatesRootSaga = function* () {
  yield all([
    fork(watchGetStatusUpdates),
    fork(watchUpdateStatusUpdates),
    fork(watchCreateStatusUpdates),
    fork(watchDeleteStatusUpdates),
  ]);
};
